var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"name-badge-container",class:{ 'is-inactive': !_vm.isActive }},[_c('i',{class:_vm.isActive ? 'el-icon-user' : 'el-icon-warning-outline'}),_c('span',{staticClass:"badge-text"},[_vm._v(_vm._s(_vm.accountName))])])}
var staticRenderFns = []

export { render, staticRenderFns }